import { createContext } from 'react';
import { fabric } from 'fabric';

const CanvasContext = createContext<fabric.Canvas>({} as fabric.Canvas);

export default CanvasContext;
